import moment from "moment";

moment.locale('nl');

export class SearchSelection {
    pickupDate?: moment.Moment;
    dropOffDate?: moment.Moment;
    pickupLocation?: string;
    dropOffLocation?: string;

    static fromUrlParams(router): SearchSelection {
        const params = router.query;
        const searchSelection = new SearchSelection();
        searchSelection.pickupDate = params['ophaaldatum'] ? moment(params['ophaaldatum'].toString()) : null;
        searchSelection.dropOffDate = params['afleverdatum'] ? moment(params['afleverdatum'].toString()) : null;
        searchSelection.pickupLocation = params['ophaallocatie'] ? params['ophaallocatie'].toString() : null;
        searchSelection.dropOffLocation = params['afleverlocatie'] ? params['afleverlocatie'].toString() : null;

        return searchSelection;
    }

    formattedPickupDate(): string {
        return this.pickupDate.format('YYYY-MM-DD')
    }

    formattedDropOffDate(): string {
        return this.dropOffDate.format('YYYY-MM-DD')
    }

    getTripLengthInDays(): number {
        return moment(this.dropOffDate).diff(moment(this.pickupDate), 'days') + 1;
    }

    isValidSelection(): boolean {
        return this.pickupDate !== null && this.dropOffDate !== null && this.pickupLocation !== null && this.dropOffLocation !== null;
    }
}
